module.exports = __webpack_public_path__ + "static/media/document-week9.09579307.pdf";